import React, { useEffect, useState } from 'react';
import About from './About';
import Contact from './Contact';
import Home from './Home';
import ProductsAndServices from './ProductsAndServices';
import Pricing from './Pricing';
import LowCode from './LowCode';
import Gallery from './Gallery';
import AIArtificialIntelligence from './AIArtificialIntelligence';
import PrivacyPolicyModel from './PrivacyPolicyModel';
import TermsConditionsModel from './TermsConditionsModel';
import { FaShieldAlt, FaFileContract } from "react-icons/fa";
import { HiDocumentText } from "react-icons/hi";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { FiGlobe } from "react-icons/fi";

const MainContent = () => {
  const [scrollMarginTop, setScrollMarginTop] = useState('60px');
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false);
  const [openTermsAndCont, setOpenTermsAndCont] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 575) {
        setScrollMarginTop('100px');
      } else {
        setScrollMarginTop('60px');
      }
    };

    // Initial check
    handleResize();

    // Listen for viewport resize
    window.addEventListener('resize', handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <main className="content">
      <Home MarginTop={scrollMarginTop} />
      <About MarginTop={scrollMarginTop} />
      <ProductsAndServices MarginTop={scrollMarginTop} />
      <AIArtificialIntelligence MarginTop={scrollMarginTop} />
      <Pricing MarginTop={scrollMarginTop} />
      <LowCode MarginTop={scrollMarginTop} />
      <Gallery MarginTop={scrollMarginTop} />
      <Contact MarginTop={scrollMarginTop} />
      <div className='privacy-and-terms'>
        <div className="policy-wrapper">
          <div className="privacy-info">
            <div className="policy-icon"><FaShieldAlt /></div>
            <div className="privacy-content">
              <h4>Your Privacy, Our Priority</h4>
              <p>
                We value your trust and are committed to
                protecting your information.
              </p>
            </div>
          </div>

          <div className="policy-links">
            <div
              className="policy-card"
              onClick={() => setOpenPrivacyPolicy(true)}
            >
              <div className="policy-icon"> <HiDocumentText className='privacy-doc-icon' /></div>
              <div className="policy-content">
                <h4>Privacy Policy</h4>
                <p>
                  Learn how we collect, use and protect
                  your personal data.
                </p>
              </div>
              <span><MdOutlineKeyboardArrowRight /></span>
            </div>

            <div
              className="policy-card"
              onClick={() => setOpenTermsAndCont(true)}
            >
              <div className="policy-icon"> <FaFileContract /></div>
              <div className="policy-content">
                <h4>Terms & Conditions</h4>
                <p>
                  Read our terms of service and usage
                  guidelines.
                </p>
              </div>
              <span><MdOutlineKeyboardArrowRight /></span>
            </div>
          </div>
        </div>
        {openPrivacyPolicy && <PrivacyPolicyModel openPrivacyPolicy={openPrivacyPolicy} setOpenPrivacyPolicy={setOpenPrivacyPolicy} />}
        {openTermsAndCont && <TermsConditionsModel openTermsAndCont={openTermsAndCont} setOpenTermsAndCont={setOpenTermsAndCont} />}
      </div>
      <div className="copy-rights-cont">
        <p className="cb-copyright-text">© 2026 All rights reserved.</p>
        <div className="cb-attribution-link-zone">
          <a href="https://bwefinserv.in/" target="_blank" rel="noopener noreferrer" className="cb-brand-anchor"><FiGlobe className='cb-globe-icon' /> BWE Finserv</a>
        </div>
      </div>
    </main>
  );
};

export default MainContent;